<button
  pButton
  pRipple
  class="round-button"
  [disabled]="disabled"
  [icon]="icon"
  [class]="color"
>
</button>
